import { useState, useEffect } from 'react';
import axios from 'axios';
import { IoDocument } from "react-icons/io5";

const BASE_URL = process.env.REACT_APP_BE_MAIN_URL;

export default function ThumbnailImage({ fileId, filename, s3Url, onThumbnailClick }) {
    const [thumbnail, setThumbnail] = useState(null);
    const [loading, setLoading] = useState(true);
    const token = sessionStorage.getItem("userToken");

    useEffect(() => {
        let isMounted = true;
        
        const fetchThumbnail = async () => {
            if (!fileId) return;
            
            try {
                const res = await axios.get(`${BASE_URL}/ocr/file-thumbnail/${fileId}/`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                
                if (isMounted && res.data.thumbnail_base64) {
                    setThumbnail(res.data.thumbnail_base64);
                }
            } catch (err) {
                // Silent fail for thumbnails
                // console.error("Failed to load thumbnail", err);
            } finally {
                if (isMounted) setLoading(false);
            }
        };

        fetchThumbnail();
        
        return () => { isMounted = false; };
    }, [fileId, token]);

    if (loading) {
        return (
            <div className="w-full h-full flex items-center justify-center bg-gray-100 animate-pulse">
                <IoDocument className="w-8 h-8 text-gray-300" />
            </div>
        );
    }

    if (thumbnail) {
        return (
            <img
                src={thumbnail}
                alt={filename}
                className="w-full h-full object-cover cursor-pointer hover:scale-105 transition-transform"
                onClick={() => onThumbnailClick && onThumbnailClick(s3Url)}
            />
        );
    }

    return (
        <div className="flex h-full items-center justify-center bg-gray-100">
            <IoDocument className="w-10 h-10 text-gray-400" />
        </div>
    );
}
